<template>
  <div>
    <select v-if='mobile' class='t-p-medium button-reset px-8 py-8 border bg-white appearance-none' v-model='computedValue' :class='inputClass' :name="name">
      <option :value='null'>{{placeholder}}</option>
      <option v-for='option in suggestions' :key='option' v-text='formatOption(option)' :value='option'></option>
    </select>
    <div v-else :class='{"dropdown dropdown--skip-js": useDropdown, "dropdown--opened": isOpened}'>
      <input class='t-label-regular' type='number' min='0' v-model.number='computedValue' :class='inputClass' :placeholder='placeholder'
        @focus='onFocus' @blur='onBlur' :name="name">
      <ul 
        :class='[listClass, {"dropdown__body bg-white z-3": useDropdown }]' 
        @mousedown='listIsFocused = true'
        @mouseup='listIsFocused = false'
        :style="useDropdown ? {} : { paddingTop: '16px' } "
      >
        <li :key='option' :class='listItemClass' 
          v-for='option in filteredSuggestions'
          v-text='formatOption(option)' 
          @click='selectOption(option)'
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import isMobile from 'ismobilejs'

  export default {
    name: 'NumberInputWithSuggestions',
    props: {
      suggestions: {
        type: Array,
        default: [],
      },
      formatOption: {
        type: Function,
        default: option => option,
      },
      inputClass: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      value: {
        type: Number,
      },
      useDropdown: {
        type: Boolean,
        default: false,
      },
      name: String,
      listClass: {
        type: String,
        default: 't-label-regular visible-desktop scroll-y mxh-240 custom-scrollbar',
      },
      listItemClass: {
        type: String,
        default: 'list-style-none px-8 py-8 hover-bg-light-gray pointer',
      }
    },
    computed: {
      computedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val || null)
        },
      },
      filteredSuggestions() {
        return this.suggestions
      }
    },
    data() {
      return {
        mobile: isMobile().any,
        isOpened: false,
        listIsFocused: false,
      }
    },
    methods: {
      onFocus() {
        this.$emit("focus")
        this.isOpened = true
      },
      selectOption(option) {
        this.computedValue = option
        this.isOpened = false
        this.$emit("change")
      },
      onBlur() {
        if (!this.listIsFocused) {
          this.isOpened = false
          this.$emit("change")
        }
      },
      checkClick(e) {
        if (!this.$el.contains(e.target) && this.isOpened) {
          this.isOpened = false
          this.$emit("change")
        }
      }
    },
    mounted() {
      document.body.addEventListener('click', this.checkClick)
    },
    beforeDestroy() {
      document.body.removeEventListener('click', this.checkClick)
    }
  }
</script>